"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./WideDivider.scss");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _variables = require("../../styles/variables");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var WideDivider =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(WideDivider, _PureComponent);

  function WideDivider() {
    _classCallCheck(this, WideDivider);

    return _possibleConstructorReturn(this, _getPrototypeOf(WideDivider).apply(this, arguments));
  }

  _createClass(WideDivider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          height = _this$props.height,
          margin = _this$props.margin,
          width = _this$props.width;
      return _react2.default.createElement("hr", {
        className: "c-WideDivider",
        style: {
          background: color || _variables.coBrandingDefaults.primary,
          height: height + 'px',
          width: width + '%',
          margin: margin
        }
      });
    }
  }]);

  return WideDivider;
}(_react.PureComponent);

WideDivider.defaultProps = {
  color: '',
  height: 5,
  width: 100,
  margin: '0'
};
exports.default = WideDivider;